import { HttpServiceBase } from '../common-services/Http/HttpServiceBase';
import { ProfileType } from '../enums/ProfileType';
import { appConfigFieldNames } from '../resources/appConfigResources';
import { zerezesErpCode } from '../resources/erpResources';
import { GetAppConfigByFieldService } from './AppConfigs/GetAppConfigByField/GetAppConfigByFieldService';

export class FeatureFlagService extends HttpServiceBase {

  constructor(
    private getAppConfigByFieldService: GetAppConfigByFieldService,
    http?: any | null
  ) {
    super(http);
  }

  currentErpIsProtheus = async (): Promise<boolean> => {
    const result = await this.getAppConfigByFieldService.handle(appConfigFieldNames.CurrentErpCodeFieldName);
    return result?.value?.config?.value === zerezesErpCode.Protheus;
  }

  expressOrdersEnabledToProfileType = async (profileType?: ProfileType | null): Promise<boolean> => {
    if (profileType === null || profileType === undefined) return false;
    const result = await this.getAppConfigByFieldService.handle(appConfigFieldNames.ExpressOrdersEnabledToProfileTypeFieldName);
    console.log('Quem pode ver opção de logística de pedido expresso:', result?.value?.config?.value);
    const configValue = (result?.value?.config?.value || '').split(',').map(p => p.trim());
    const profileTypeStr = profileType.toString();
    return configValue.some(p => p == profileTypeStr);
  }
}